import { AbstractDynamicComponentsDictionary, ComponentItem } from '@linkdev/shared-library';
import { Injectable } from "@angular/core";
import { RequestPriorityComponent, RequestParticipantComponent, RequesterInfoComponent, RequestAttachmentsComponent, RequestFeesComponent, PaidReceiptsComponent, SubRequestsListComponent, ParentRequestComponent } from '@linkdev/service-management-library';
//import { FoodImporterLicenseRequestComponent, GraduationCertificateRequestComponent, IndustrialRecordRequestComponent, LabAccreditationRequestComponent, LabAccreditationRequestPolicyComponent, LicenseRequestServiceComponent, SoleProprietorshipsRequestComponent } from '@linkdev/mota-service-library';
import { MyRequestTasksWrapperComponent } from '@linkdev/portals-shared'; 
import { 
    ContactUsComponent, 
    GetInvolvedComponent, 
    GetInvolvedDepartmentComponent, 
    MicrogravityresearchComponent, 
    OpenCallForIdeaComponent, 
    OpenCallRFIComponent, 
    ProposalSubmissionRFIComponent, 
    PublishRFIComponent, 
    RespondToRFIComponent,
    ReviewContactUsComponent,
    RequestOpenDataComponent,
    EventAttendeeCategoryComponent,
    EventRegistrationFormComponent,
    RequestOpenDataAttachmentComponent,
    BecomeAPartnerDepartmentComponent,
    BecomeaPartnerComponent,
    RquiredInputComponent,
    DataSharingComponent,
    ReviewDataSharingComponent,
    DepartmentReviewDataSharingComponent
 } from '@linkdev/ssa-shared';



@Injectable()
export class DynamicComponentsDictionary implements AbstractDynamicComponentsDictionary {
    public getDynamicComponents(): ComponentItem[] {
        return this._dynamicComponents; 
    }

    private _dynamicComponents: ComponentItem[] = [
        new ComponentItem(RequesterInfoComponent, "RequesterInfo"),
        new ComponentItem(RequestAttachmentsComponent, "RequestAttachments"),
        new ComponentItem(RequestFeesComponent, "RequestFees"),
        new ComponentItem(PaidReceiptsComponent, "PaidReceipts"),
        new ComponentItem(RequestParticipantComponent, "RequestParticipant"),
        new ComponentItem(RequestPriorityComponent, "RequestPriority"),
  
     //   new ComponentItem(SubRequestsListComponent, "SubRequestsListComponent"),
     //   new ComponentItem(ParentRequestComponent, "ParentRequestComponent"),
    //    new ComponentItem(BirthCertificateBirthLocationComponent, "BirthCertificateRequestBirthLocation"),
     //   new ComponentItem(BirthCertificateBasicDataComponent, "BirthCertificateRequestBasicData"),
     //   new ComponentItem(LicenseRequestServiceComponent, "RequestLicenseForm"),
     //   new ComponentItem(IndustrialRecordRequestComponent, "IndustrialRecordRequestForm"),
      //  new ComponentItem(LabAccreditationRequestComponent, "LabAccreditationRequestForm"),
      //  new ComponentItem(LabAccreditationRequestPolicyComponent, "LabAccreditationRequestPolicies"),
      //  new ComponentItem(SoleProprietorshipsRequestComponent, "SoleProprietorshipsRequestForm"),
      //  new ComponentItem(GraduationCertificateRequestComponent, "GraduationCertificateRequestForm"),
      //  new ComponentItem(FoodImporterLicenseRequestComponent, "FoodImporterLicenseRequestForm"),

      //  new ComponentItem(BirthCertificateBirthLocationComponent, "BirthCertificateRequestBirthLocation"),
       // new ComponentItem(BirthCertificateBasicDataComponent, "BirthCertificateRequestBasicData"),
     //   new ComponentItem(LicenseRequestServiceComponent, "RequestLicenseForm"),
      //  new ComponentItem(IndustrialRecordRequestComponent, "IndustrialRecordRequestForm"),
       // new ComponentItem(LabAccreditationRequestComponent, "LabAccreditationRequestForm"),
       // new ComponentItem(LabAccreditationRequestPolicyComponent, "LabAccreditationRequestPolicies"),
       // new ComponentItem(SoleProprietorshipsRequestComponent, "SoleProprietorshipsRequestForm"),
        //new ComponentItem(GraduationCertificateRequestComponent, "GraduationCertificateRequestForm"),
       // new ComponentItem(FoodImporterLicenseRequestComponent, "FoodImporterLicenseRequestForm"),
       new ComponentItem(RequestOpenDataComponent, "RequestOpenData"), 
       new ComponentItem(RequestOpenDataAttachmentComponent,"RequestopendataAttachment"),

       new ComponentItem( BecomeaPartnerComponent,"BecomeAPartner"),
       new ComponentItem( BecomeAPartnerDepartmentComponent,"BecomeAPartnerDepartment"),
       
       new ComponentItem(RquiredInputComponent,"RequestOpenDataRequiredInput"), 
       
        new ComponentItem(MyRequestTasksWrapperComponent, "MyRequestTasksWrapperComponent"),
        new ComponentItem(OpenCallForIdeaComponent, "OpenCallForIdea"),
        new ComponentItem(MicrogravityresearchComponent, "Microgravityresearch"),
       // new ComponentItem(TermsAndConditionsComponent, "TermsAndConditions"),
        new ComponentItem(ContactUsComponent,"ContactUs"),
        new ComponentItem(ReviewContactUsComponent,"ReviewContactUs"),
        new ComponentItem(OpenCallRFIComponent, "OpenCallRFI"),
        new ComponentItem(PublishRFIComponent, "PublishRFI"),
        new ComponentItem(ProposalSubmissionRFIComponent, "ProposalSubmissionRFI"),
        new ComponentItem(RespondToRFIComponent, "RespondToRFI"),

        new ComponentItem(GetInvolvedComponent, "GetInvolved"),
        new ComponentItem(GetInvolvedDepartmentComponent, "GetInvolvedDepartment"),
        new ComponentItem(EventAttendeeCategoryComponent, "EventAttendeeCategoryComponent"),
        new ComponentItem(EventRegistrationFormComponent, "EventRegistrationFormComponent"),

        new ComponentItem(DataSharingComponent,"DataSharing"),
        new ComponentItem(ReviewDataSharingComponent,"ReviewDataSharing"),
        new ComponentItem(DepartmentReviewDataSharingComponent,"DepartmentReviewDataSharing"),
    ]
}
